<template>
  <div class="page-product-marketing">
    <section class="py-5 bg11 mobile-top">
      <div class="container">
        <h1 class="text-white mb0 lh1">The Attic: A Spacesaver Podcast</h1>
        <hr data-v-1bb75403="" class="header-divide">
        <h5 data-v-1bb75403="" class="text-white mb0 lh1"> Your source for staying up-to-date with all things Spacsaver.</h5>
      </div>
    </section>

    <div class="container">
      <div class="row mt20">
        <div class="col-xs-12 col-sm-12 col-12 col-lg-12">
          <!-- Wrapped the player div in a class for easy clipping -->
          <div class="player-container" style="width: 100%; height: 600px; margin-bottom: 20px; border-radius: 6px; overflow: hidden;">
            <iframe
              style="width: 100%; height: 600px; display: block;"
              frameborder="no"
              scrolling="no"
              allow="clipboard-write"
              seamless
              src="https://player.captivate.fm/show/25a785cd-8f20-4c7e-a232-b6aa1f4c3d7e"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const auth = {
  headers: {
    Authorization: "Bearer spacesaver/ab3f641f910eb693804bc5b097a5bda6",
  },
};

export default {
  name: "PodcastsCollection",
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
  created() {
    this.$store.commit("showNavigation");
  }
}
</script>

<style scoped>
/* Your existing scoped styles remain unchanged */
.post {
  background: #fff;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
/* ... rest of your scoped styles ... */
</style>

<style>
/* Re-use the same clip that worked for the other player */
.player-container {
  clip-path: inset(2px);          /* clips 2px inward on all sides to hide thin shadow bleed */
  -webkit-clip-path: inset(2px);  /* Safari compatibility */
  background: white;              /* prevents any transparent edge showing after clip */
}

/* Optional: force iframe bg to blend perfectly */
iframe {
  background: white !important;
  border: none !important;
}
</style>